import escapeCssUrl from "sk2tch/utils/escape-css-url";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import _ from "lodash";

const TAPE = [
  require("../assets/tape1.png"),
  require("../assets/tape2.png"),
  require("../assets/tape3.png"),
  require("../assets/tape4.png"),
  require("../assets/tape5.png"),
];

function pseudoRandom(seed) {
  return Math.abs(Math.cos(Math.sin(seed / 1000) * 1000) * 10000) % 1;
}

export default function Main() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { isPending, error, data } = useQuery({
    queryKey: ["feed"],
    queryFn: () => fetch("/api/feed").then((res) => res.json()),
  });

  if (isPending) {
    return "Loading...";
  }

  if (error || !data) {
    return <h1>Oopsies</h1>;
  }

  // Reduce. Go through data.events and if the event.venue and event.date are the same then combine them.
  const eventHashes = {};
  const filteredEvents = [];
  for (let event of data.events) {
    const date = new Date(event.date);
    const hash = `v-${date.getMonth()}-${date.getDate()}-${date.getFullYear()}-${event.venue?.toLowerCase()}`;
    if (eventHashes[hash]) {
      continue;
    } else {
      eventHashes[hash] = event;
    }
    const hash2 = `t-${date.getMonth()}-${date.getDate()}-${date.getFullYear()}-${event.title?.toLowerCase()}`;
    if (eventHashes[hash2]) {
      continue;
    } else {
      eventHashes[hash2] = event;
    }

    filteredEvents.push(event);
  }

  return (
    <>
      <h1>
        <hen>hẹn</hen>list.cơm
        <sub>
          <inner>hẹn gặp ở đâu?</inner>
        </sub>
      </h1>
      <p>
        ? stuff happening in saigon. scraped daily from curated list of
        instagrams. info not 100% accurate. by{" "}
        <a
          href="https://instagram.com/nohurryhen"
          target="_blank"
          rel="noopener noreferrer"
        >
          @nohurryhen
        </a>
      </p>
      <div className="cards">
        {filteredEvents.map((event) => {
          const daysUntilEvent = Math.round(
            (new Date(event.date).getTime() - Date.now()) /
              (1000 * 60 * 60 * 24),
          );
          const dayOfWeekName = new Date(event.date).toLocaleDateString(
            "en-US",
            {
              weekday: "long",
            },
          );
          const monthDay = new Date(event.date).toLocaleDateString("en-US", {
            month: "long",
            day: "numeric",
          });
          const hash = Array.from(event.short_code).reduce(
            (a, b) => a + b.charCodeAt(0),
            0,
          );
          if (dayOfWeekName === "Invalid Date" || monthDay === "Invalid Date") {
            return null; // Skip rendering this event if the date is invalid.
          }
          return (
            <div
              className={["card", daysUntilEvent <= 0 ? "expired" : ""].join(
                " ",
              )}
              key={event.short_code}
            >
              <div
                className="tape-top"
                style={{
                  backgroundImage: `url(${escapeCssUrl(TAPE[(pseudoRandom(hash * 5) * TAPE.length) | 0])})`,
                  transform: `rotate(${pseudoRandom(hash * 5) * 20 - 10}deg) translateX(${pseudoRandom(hash + 1) * 30 - 15}%)`,
                }}
              ></div>
              <h3>{event.title}</h3>
              <div>
                ((
                {daysUntilEvent > 0
                  ? `${daysUntilEvent} days left`
                  : `Event has passed`}
                ))
              </div>
              <div>
                {dayOfWeekName}, {monthDay}
              </div>
              <div style={{ fontStyle: "italic" }}>{event.venue}</div>
              <div
                className="preview"
                style={{
                  backgroundImage: `url(/api/thumbnail/${event.short_code})`,
                }}
              ></div>
              <div className="read-more">
                <a
                  href={`https://instagram.com/p/${event.short_code}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="inactive">
                    <span className="eyes">
                      <img src={require("../assets/look.gif")} />
                      {" .. "}
                    </span>
                    read more {">>"}{" "}
                  </span>
                  <span className="active">hẹn gặp lại!</span>
                </a>
              </div>
              {/* <div
                className="tape-bottom"
                style={{
                  backgroundImage: `url(${escapeCssUrl(TAPE[(pseudoRandom(hash + 200) * TAPE.length) | 0])})`,
                  transform: `rotate(${pseudoRandom(hash + 100) * 20 - 10}deg) translateX(${pseudoRandom(hash + 1) * 30 - 15}%)`,
                }}
              ></div> */}
            </div>
          );
        })}
      </div>
    </>
  );
}
